import Vue from 'vue'
import Vuex from 'vuex'
import gql from 'graphql-tag'
import { apolloClient } from '../vue-apollo'

Vue.use(Vuex)

const FETCH_PORTION_CONFIG = gql`
  query fetchPortionConfig {
    isPortioningEnabled {
      isEnabled
    }
    getActivePortions {
      _id
      name
      value
      calorieRange
      isActive
    }
  }
`

const store = new Vuex.Store({
  state: {
    drawerState: null,
    isPortionEnabled: false,
    activePortions: [],
  },
  mutations: {
    toggleDrawerState(state) {
      state.drawerState = !state.drawerState
    },
    SET_PORTION_CONFIG(state, { isPortionEnabled, activePortions }) {
      state.isPortionEnabled = isPortionEnabled
      state.activePortions = activePortions
    },
  },
  actions: {
    async fetchPortionConfig({ commit }) {
      try {
        const { data } = await apolloClient.query({
          query: FETCH_PORTION_CONFIG,
          fetchPolicy: 'network-only',
        })
        commit('SET_PORTION_CONFIG', {
          isPortionEnabled: data.isPortioningEnabled.isEnabled,
          activePortions: data.getActivePortions,
        })
      } catch (error) {
        console.error('Error fetching portion config:', error)
      }
    },
  },
  modules: {
  }
})

// Re-fetch portion config automatically after every Apollo store reset (e.g. after login)
apolloClient.onResetStore(() => store.dispatch('fetchPortionConfig'))

export default store